import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";

import Test1 from "./Pages/test1";
import Home from "./Pages/Home";
import firebase from "@firebase/app-compat";
import CreateArticle from "./Pages/CreateArticle";
import ArticlePage from "./Pages/ArticlePage";
import EditArticlePage from "./Pages/EditArticlePage";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
function App() {
  const [user, setUser] = React.useState(null);
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (userData) => {
      if (userData) {
        setUser(userData);
      } else {
        setUser(null);
      }
    });
  }, []);

  return (
    <div className="App" id="like_button_container">
      <Router>
        <Switch>
          {/* 首頁 */}
          <Route exact path="/">
            <Header />
            <Home></Home>
          </Route>
          {/* test */}
          <Route path="/test1">
            {/*Test1() */}
            <Test1></Test1>
          </Route>

          {/* 編輯頁面 */}
          <Route path="/edit/:aid">
            <EditArticlePage></EditArticlePage>
          </Route>

          <Route path="/createArticle/">
            <CreateArticle></CreateArticle>
          </Route>

          {/* 文章頁面 
            <Route path="/article/:genre/:cate/:subcate/:aid">
            */}
          <Route path="/article/:aid">
            <Header></Header>
            <ArticlePage></ArticlePage>
          </Route>

          {/*若輸入其他網址會導入noFound頁面 */}
          <Route path="/*">404</Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
